import { render, staticRenderFns } from "./ProductsLiabilityBenefits.vue?vue&type=template&id=8aaaca02"
import script from "./ProductsLiabilityBenefits.vue?vue&type=script&lang=js"
export * from "./ProductsLiabilityBenefits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports